/**
 * Get the last used TV view URL from localStorage.
 * Returns the appropriate path based on the saved view mode.
 */
export function getLastTVViewUrl() {
  const savedViewMode = localStorage.getItem("tv-view-mode") || "multiday";
  
  // Map view modes to their routes
  switch (savedViewMode) {
    case "today":
      return "/admin/prayer-times-view";
    case "multiday":
      return "/admin/tv-viewer";
    case "events":
      return "/admin/tv-viewer";
    case "images":
      return "/admin/tv-viewer";
    default:
      return "/admin/tv-viewer";
  }
}

/**
 * Get the navigation state for TV viewer based on saved view mode.
 * Returns state object for react-router navigate.
 */
export function getLastTVViewState() {
  const savedViewMode = localStorage.getItem("tv-view-mode") || "multiday";
  
  switch (savedViewMode) {
    case "today":
      return {}; // PrayerTimesView doesn't need state
    case "multiday":
      return { viewMode: "none" };
    case "events":
      return { viewMode: "events" };
    case "images":
      return { viewMode: "images" };
    default:
      return { viewMode: "none" };
  }
}

/**
 * Navigate to the last used TV view.
 * @param {Function} navigate - React Router navigate function
 */
export function navigateToLastTVView(navigate) {
  const url = getLastTVViewUrl();
  const state = getLastTVViewState();
  
  if (url === "/admin/prayer-times-view") {
    navigate(url);
  } else {
    navigate(url, { state });
  }
}
